import { useParams } from '@tanstack/react-router'

export const useBranchId = () => {
    const { branchId } = useParams({ from: '/_dashboard/branch/$branchId' })

    return branchId
}
